module.exports = __webpack_public_path__ + "static/media/top-quality.cbb326fa.svg";